import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuthStore } from "@/store/authStore";

export function AdminPublicRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const role = useAuthStore((state) => state.user?.role);

  if (isAuthenticated) {
    if (role === "admin" || role === "owner") {
      return <Navigate replace to="/admin" />;
    }

    return <Navigate replace to="/app/files" />;
  }

  return <>{children}</>;
}
